<template>
  <div :class="groupClass">
    <BaseShowEditSelectAjax
      :edition-mode="true"
      :model-value="modelValue"
      :default-ajax="defaultAjax"
      :url="url"
      :name="name"
      :label="label"
      :track-by="trackBy"
      :attribute-label="attributeLabel"
      :required="required"
      :errors="errors"
      @update:model-value="onSelect"
    />
  </div>
</template>

<script>
import BaseShowEditSelectAjax from './BaseShowEditSelectAjax.vue'

/**
 * The former package's ajax select, which Crema's forms still use (the
 * Funeral Manager copy is an empty stub): searches `url`, starts from the
 * `defaultAjax` object, `v-model` on the selected id, and emits
 * `setSelected` / `selected` with `{ attribute, value }`.
 */
export default {
  name: 'BaseSelectSimpleAjax',
  components: { BaseShowEditSelectAjax },
  props: {
    modelValue: {
      type: [Number, String],
      required: false,
      default: null
    },
    defaultAjax: { type: Object, required: false, default: () => ({}) },
    url: { type: String, required: true },
    name: { type: String, required: false, default: null },
    label: { type: String, required: false, default: null },
    trackBy: { type: String, required: false, default: 'id' },
    attributeLabel: { type: String, required: false, default: 'name' },
    required: { type: Boolean, required: false, default: false },
    errors: { type: [Object, Array], required: false, default: () => [] },
    groupClass: { type: String, required: false, default: '' }
  },
  emits: ['update:modelValue', 'setSelected', 'selected'],
  methods: {
    onSelect(value) {
      this.$emit('update:modelValue', value)
      const payload = { attribute: this.name, value }
      this.$emit('setSelected', payload)
      this.$emit('selected', payload)
    }
  }
}
</script>
